import { Model } from './model';
import { Type } from 'class-transformer';
import { DeductionReason } from './deduction_reason';
import { Vendor } from './vendor';

export class DeductionCreditMemoLineItem extends Model {
  id: string;

  currency: string;

  description: string;

  gross_amount: string;

  quantity: string;

  price: string;

  vendor_id: string | null;

  @Type(() => Vendor)
  vendor: Vendor | null;

  @Type(() => DeductionReason)
  reason: DeductionReason | null;

  custom_fields: Record<string, any>;
}
